import { z } from "zod";

export const currencyEnum = z.enum(["NGN", "USD", "GBP", "EUR"]);
export const countryOptionsEnum = z.enum(["GB", "NG", "US"]);
// This is alot!!
export const countryCodeEnum = z.enum([
  "AD",
  "AE",
  "AF",
  "AG",
  "AI",
  "AL",
  "AM",
  "AO",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AW",
  "AX",
  "AZ",
  "BA",
  "BB",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BI",
  "BJ",
  "BL",
  "BM",
  "BN",
  "BO",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BV",
  "BW",
  "BY",
  "BZ",
  "CA",
  "CC",
  "CD",
  "CF",
  "CG",
  "CH",
  "CI",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CR",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DE",
  "DJ",
  "DK",
  "DM",
  "DO",
  "DZ",
  "EC",
  "EE",
  "EG",
  "EH",
  "ER",
  "ES",
  "ET",
  "FI",
  "FJ",
  "FK",
  "FM",
  "FO",
  "FR",
  "GA",
  "GD",
  "GE",
  "GF",
  "GG",
  "GH",
  "GI",
  "GL",
  "GM",
  "GN",
  "GP",
  "GQ",
  "GR",
  "GS",
  "GT",
  "GU",
  "GW",
  "GY",
  "HK",
  "HM",
  "HN",
  "HR",
  "HT",
  "HU",
  "ID",
  "IE",
  "IL",
  "IM",
  "IN",
  "IO",
  "IQ",
  "IR",
  "IS",
  "IT",
  "JE",
  "JM",
  "JO",
  "JP",
  "KE",
  "KG",
  "KH",
  "KI",
  "KM",
  "KN",
  "KP",
  "KR",
  "KW",
  "KY",
  "KZ",
  "LA",
  "LB",
  "LC",
  "LI",
  "LK",
  "LR",
  "LS",
  "LT",
  "LU",
  "LV",
  "LY",
  "MA",
  "MC",
  "MD",
  "ME",
  "MF",
  "MG",
  "MH",
  "MK",
  "ML",
  "MM",
  "MN",
  "MO",
  "MP",
  "MQ",
  "MR",
  "MS",
  "MT",
  "MU",
  "MV",
  "MW",
  "MX",
  "MY",
  "MZ",
  "NA",
  "NC",
  "NE",
  "NF",
  "NG",
  "NI",
  "NL",
  "NO",
  "NP",
  "NR",
  "NU",
  "NZ",
  "OM",
  "PA",
  "PE",
  "PF",
  "PG",
  "PH",
  "PK",
  "PL",
  "PM",
  "PN",
  "PR",
  "PS",
  "PT",
  "PW",
  "PY",
  "QA",
  "RE",
  "RO",
  "RS",
  "RU",
  "RW",
  "SA",
  "SB",
  "SC",
  "SD",
  "SE",
  "SG",
  "SH",
  "SI",
  "SJ",
  "SK",
  "SL",
  "SM",
  "SN",
  "SO",
  "SR",
  "SS",
  "ST",
  "SV",
  "SX",
  "SY",
  "SZ",
  "TC",
  "TD",
  "TF",
  "TG",
  "TH",
  "TJ",
  "TK",
  "TL",
  "TM",
  "TN",
  "TO",
  "TR",
  "TT",
  "TV",
  "TW",
  "TZ",
  "UA",
  "UG",
  "UM",
  "US",
  "UY",
  "UZ",
  "VA",
  "VC",
  "VE",
  "VG",
  "VI",
  "VN",
  "VU",
  "WF",
  "WS",
  "XK",
  "YE",
  "YT",
  "ZA",
  "ZM",
  "ZW",
]);

export const usdAccountTypeOptionsEnum = z.enum(["ach", "fed-wire", "swift"]);
export const ngnAccountSchema = z.object({
  country: z.string().trim().min(1, "Required").default("NG"),
  account_name: z.string().trim().min(1, "Required"),
  account_number: z
    .string()
    .trim()
    .refine((val) => /^\d+(\.\d+)?$/.test(val), {
      message: "Input is not a valid number",
    }),
  bank_name: z.string().trim().min(1, "Required"),

  bank_code: z.string().trim().min(1, "Required"),
  currency: z.literal(currencyEnum.enum.NGN).default("NGN"),
});

const gbVaryingCountryAccountSchema = z.object({
  country: z.literal(countryOptionsEnum.enum.GB),
  account_number: z.string().trim().min(1, "Required"),
  sort_code: z.string().trim().min(1, "Required"),
});

const anyCountryVaryingAccountSchema = z.object({
  country: countryCodeEnum,

  iban: z.string().trim().min(1, "Required"),
  swift: z.string().trim().min(1, "Required"),
});

const defaultVaryingCountryAccountSchema = z.object({
  country: z.string().trim().min(1, "Required"),
  currency: z.literal(currencyEnum.enum.EUR).default("EUR"),
  account_name: z.string().trim().min(1, "Required"),
  bank_name: z.string().trim().min(1, "Required"),
});

const varyingCountryAccountConditionalSchema = z.discriminatedUnion("country", [
  gbVaryingCountryAccountSchema,
  anyCountryVaryingAccountSchema,
]);

export const varyingCountryAccountSchema = z.intersection(
  defaultVaryingCountryAccountSchema,
  varyingCountryAccountConditionalSchema
);

const achUsdAccountSchema = z.object({
  type: z.literal(usdAccountTypeOptionsEnum.enum.ach),
  account_routing_number: z.string().trim().min(1, "Required"),
  account_number: z.string().trim().min(1, "Required"),
});
const fedWireUsdAccountSchema = z.object({
  type: z.literal(usdAccountTypeOptionsEnum.enum["fed-wire"]),
  account_routing_number: z.string().trim().min(1, "Required"),
  account_number: z.string().trim().min(1, "Required"),
});
const swiftUsdAccountSchema = z.object({
  type: z.literal(usdAccountTypeOptionsEnum.enum.swift),
  iban: z.string().trim().min(1, "Required"),
  swift: z.string().trim().min(1, "Required"),
  // bank_code: z.string().trim().min(1, "Required"),
});
export const defaultUsdAccountSchema = z.object({
  currency: z.literal(currencyEnum.enum.USD).default("USD"),
  country: z.string().trim().min(1, "Required"),
  account_name: z.string().trim().min(1, "Required"),
  bank_name: z.string().trim().min(1, "Required"),
});

const usdAccountConditionalSchema = z.discriminatedUnion("type", [
  achUsdAccountSchema,
  swiftUsdAccountSchema,
  fedWireUsdAccountSchema,
]);
export const usdAccountSchema = z.intersection(
  defaultUsdAccountSchema,
  usdAccountConditionalSchema
);

// export const gbpAccountSchema = z.object({
//   // currency: z.literal(currencyEnum.enum.GBP),
//   account_name: z.string().trim().min(1, "Required"),
//   sort_code: z
//     .string()
//     .trim()
//     .refine((val) => /^\d+(\.\d+)?$/.test(val), {
//       message: "Input is not a valid number",
//     }),
// });

export type NgnAccountSchemaDto = z.infer<typeof ngnAccountSchema>;
export type UsdAccountSchemaDto = z.infer<typeof usdAccountSchema>;
export type GbpAccountSchemaDto = z.infer<typeof varyingCountryAccountSchema>;
export type EurAccountSchemaDto = z.infer<typeof varyingCountryAccountSchema>;
export type CurrencyEnum = z.infer<typeof currencyEnum>;

export const settlementAccountsSchema = z
  .object({
    ngn_account: z.array(ngnAccountSchema),
    usd_account: z.array(usdAccountSchema),
    gbp_account: z.array(varyingCountryAccountSchema),
    eur_account: z.array(varyingCountryAccountSchema),
    agree_to_terms: z.literal<boolean>(true, {
      errorMap: () => ({ message: "Required" }),
    }),
    correct_documents: z.literal<boolean>(true, {
      errorMap: () => ({ message: "Required" }),
    }),
  })
  .partial();

export type SettlementAccountsSchemaDto = z.infer<
  typeof settlementAccountsSchema
>;
